/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Addr_Sugg_Accept_HighInputs */

const cs_addr_sugg_accept_high = /** @type {(inputs: Addr_Sugg_Accept_HighInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Přijmout jisté (${i?.count})`)
};

const en_addr_sugg_accept_high = /** @type {(inputs: Addr_Sugg_Accept_HighInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Accept high-confidence (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Accept high-confidence ({count})" |
*
* @param {Addr_Sugg_Accept_HighInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_accept_high = /** @type {((inputs: Addr_Sugg_Accept_HighInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_Accept_HighInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_accept_high(inputs)
	return cs_addr_sugg_accept_high(inputs)
});